export default __webpack_public_path__ + "static/media/find.a721d0d7.svg";